<template>
	<div class="md-layout">
		<div class="md-layout-item md-size-66">
			<form-card
				title="Modification d'un secteur"
				icon="edit"
				v-model="sector.name"
				:goBack="goBack"
				:save="updateSector"
				:error="error">
			</form-card>
		</div>
		<div class="md-layout-item md-size-66">
			<md-card>
				<md-card-header class="md-card-header-icon md-card-header-blue">
					<div class="card-icon">
						<font-awesome-icon class="md-icon" :icon="['fas', 'clipboard-list']"/>
					</div>
					<h4 class="title">Liste des sites concernés</h4>
				</md-card-header>

				<md-card-content>
					<div v-for="site in sector.sites" :key="site.id" class="md-layout md-alignment-center-left">
						<div class="md-layout-item md-size-50">
							<div class="flex flex-col justify-center">
								<div class="font-bold leading-none mb-1">{{ site.name }}</div>
								<small class="leading-none">Client : {{ site.client.name }}</small>
							</div>
						</div>
						<div class="md-layout-item md-size-35">
							<md-field>
								<label for="sectors">Secteur</label>
								<md-select name="sectors" id="sectors" v-model="site.sector_id">
									<md-option v-for="sector in sectors" :key="sector.id" :value="sector.id">
										{{ sector.name }}
									</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-size-15">
							<md-button class="md-info md-sm w-full" @click="updateSite(site)">Changer</md-button>
						</div>
					</div>
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>
import FormCard from "@/pages/Configuration/components/FormCard";

export default {
	name: "SectorEdit",
	components: { FormCard },
	data() {
		return {
			sector: {
				name: null,
				sites: []
			},
			error: null,
			sectors: [],
		}
	},
	methods: {
		async getSectorDetails() {
			const { data } = await this.$store.dispatch('sectors/getSectorDetails', { id: this.$route.params.id })
			this.sector = data
		},
		async getSectors() {
			const { data } = await this.$store.dispatch('sectors/getSectors')
			this.sectors = data
		},
		async updateSector() {
			try {
				this.error = null
				await this.$store.dispatch('sectors/updateSector', this.sector)
				await this.$store.dispatch("alerts/success", "Secteur modifié");
				await this.getSectors()
			} catch (e) {
				this.error = e.response.data.errors
			}
		},
		async updateSite(site) {
			try {
				await this.$store.dispatch('sites/updateSector', {
					id: site.id,
					sector_id: site.sector_id
				})
				await this.$store.dispatch('alerts/success', 'Site modifié')
				await this.getSectorDetails()
			} catch (e) {
				await this.$store.dispatch('alerts/error', 'Une erreur est survenue')
			}
		},
		goBack() {
			this.$router.back();
		},
	},
	mounted() {
		this.getSectorDetails()
		this.getSectors()
	}
}
</script>

<style scoped>

</style>
